import Obj from 'core/utility/object'
import {createBrowserHistory} from 'history'
import queryStringParser from 'query-string'
import {queryString as objectQueryString} from 'object-query-string'
import {currentRoute, navigateTo} from './navigator'
import ltrim from '../utility/string/ltrim'
const history = createBrowserHistory()

export const queryString = () => {
  const query = queryStringParser.parse(history.location.search, {
    parseNumbers: true,
    parseBooleans: true,
    arrayFormat: 'bracket',
  })

  return {
    /**
     * Get value from the query string by the given key
     *
     * @param {string} key
     * @param {any} defaultValue
     * @returns {any}
     */
    get: (key: string, defaultValue: any = null): any => {
      return Obj.get(query, key, defaultValue)
    },

    /**
     * Return all query string
     *
     * @returns {object}
     */
    all: (): object => query,

    /**
     * return query string as string
     *
     * @returns {string}
     */
    toString: (): string => history.location.search,
  }
}

export function updateQueryString(queryString: Record<string, any>, navigate: boolean = false) {
  // Access the current URL and search parameters
  const url = new URL(window.location.href);


  if (Object.keys(queryString).length === 0) {
    // Clear all query parameters if queryString is empty
    if (navigate) {
        navigateTo(currentRoute())
    } else {
      window.history.replaceState({}, '', url.pathname); // Update the URL without reloading
    }
    return;
  }

  const searchParams = url.searchParams;

  // Update the query string with new key-value pairs
  Object.keys(queryString).forEach((key) => {
    const value = queryString[key];
    if (value !== undefined && value !== null) {
      searchParams.set(key, value.toString());
    } else {
      // Remove key if value is undefined or null
      searchParams.delete(key);
    }
  });

  const updatedQueryString = searchParams.toString();

  window.history.replaceState({}, '', `${url.pathname}?${updatedQueryString}`);

  if (navigate) {
    var route = currentRoute().split('?')[0]
    navigateTo(route + updatedQueryString)
  }
}

export default history

export function routerHash(withHash= false) {
  var hash = history.location.hash;

  return withHash ? hash : ltrim(hash, "#");
}
